import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'




// DELETE A FORM CATEGORY
const submit = (payload) => client.put('forms/categories', payload);
export const useDeleteFormCategory = (id,payload) => useMutation(['deleteFormCategory',id],() => submit(payload))